import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { hasPermission } from "../config/permissions";

/**
 * Blocks non-admin app usage when app_config/panel.maintenanceMode is true.
 * Admins can reach /admin to turn it off. Login stays reachable.
 */
export default function MaintenanceGate({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const [maintenance, setMaintenance] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const ref = doc(db, "app_config", "panel");
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const d = snap.data() || {};
        setMaintenance(!!d.maintenanceMode);
        setMessage(String(d.maintenanceMessage || "").trim());
      },
      () => setMaintenance(false)
    );
    return () => unsub();
  }, []);

  const path = location.pathname || "";
  const isLogin = path === "/login" || path === "/";
  const savedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  })();
  const isAdmin =
    user?.role === "admin" ||
    user?.role === "administrator" ||
    savedUser?.role === "admin" ||
    savedUser?.role === "administrator" ||
    hasPermission(savedUser, "admin");

  if (!maintenance || isLogin || isAdmin || path.startsWith("/admin")) {
    return children;
  }
  if (!user?.uid) {
    return children;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-900 px-6 text-center text-slate-100">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Maintenance</p>
      <h1 className="mt-3 text-2xl font-bold">We&apos;ll be back shortly</h1>
      <p className="mt-2 max-w-md text-sm text-slate-300">
        {message || "The application is temporarily unavailable. Please try again later."}
      </p>
    </div>
  );
}
